module.exports = __webpack_public_path__ + "static/media/readiness-close-icon.6d29c6e2.svg";